const adaptEditBrand = (
	data: Partial<AppBrand> & { audienceGroupId?: number | null }
): Partial<IAppBrand> & { audience_group_id?: number | null } => {
	return {
		id: data.id,
		name: data.name,
		brand_color: data.brandColor,
		text_color: data.textColor,
		audience_group_id: data.audienceGroupId ?? null
	};
};

export default adaptEditBrand;
